import { FiasRoomType, FiasFlatType, } from '../types';
var FiasData = /** @class */ (function () {
    function FiasData(data) {
        this.data = data;
    }
    Object.defineProperty(FiasData.prototype, "name", {
        get: function () {
            var data = this.data;
            if (FiasData.isAddressObject(data)) {
                return data.name;
            }
            else if (FiasData.isStead(data)) {
                return data.number;
            }
            else if (FiasData.isHouse(data)) {
                return data.number || data.structureNumber || data.buildingNumber || '';
            }
            else if (FiasData.isGarHouse(data)) {
                return data.houseNum || '';
            }
            else if (FiasData.isRoom(data)) {
                return data.flatNumber;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "official", {
        get: function () {
            if (FiasData.isAddressObject(this.data) && FiasData.isRegion(this.data)) {
                var _a = this.data, name_1 = _a.name, abbreviation = _a.abbreviation, official = _a.official;
                switch (abbreviation) {
                    case 'г': {
                        return official.replace(/Город/, 'город');
                    }
                    case 'обл.':
                        return name_1 + " \u043E\u0431\u043B\u0430\u0441\u0442\u044C";
                    default:
                        return official;
                }
            }
            else {
                return '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "abbreviation", {
        get: function () {
            return FiasData.isAddressObject(this.data) ? this.data.abbreviation : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "code", {
        get: function () {
            return (FiasData.isAddressObject(this.data) && this.data.code) || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "number", {
        get: function () {
            return (FiasData.isStead(this.data) || FiasData.isHouse(this.data)) && this.data.number ? this.data.number : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "structureNumber", {
        get: function () {
            return FiasData.isHouse(this.data) && this.data.structureNumber ? this.data.structureNumber : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "buildingNumber", {
        get: function () {
            return FiasData.isHouse(this.data) && this.data.buildingNumber ? this.data.buildingNumber : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "fiasId", {
        get: function () {
            return this.data.fiasId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "parentFiasIds", {
        get: function () {
            if (!this.data) {
                return [];
            }
            var _a = this.data, parentFiasId = _a.parentFiasId, parentFiasIds = _a.parentFiasIds;
            return parentFiasIds || (parentFiasId ? [parentFiasId] : []);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "postalCode", {
        get: function () {
            return (this.data && this.data.postalCode) || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "estateStatus", {
        get: function () {
            if (FiasData.isHouse(this.data)) {
                return this.data.estateStatus;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "structureStatus", {
        get: function () {
            if (FiasData.isHouse(this.data)) {
                return this.data.structureStatus;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "houseNum", {
        get: function () {
            if (FiasData.isGarHouse(this.data)) {
                return this.data.houseNum;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "houseType", {
        get: function () {
            if (FiasData.isGarHouse(this.data)) {
                return this.data.houseType;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "addNum1", {
        get: function () {
            if (FiasData.isGarHouse(this.data)) {
                return this.data.addNum1;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "addNum2", {
        get: function () {
            if (FiasData.isGarHouse(this.data)) {
                return this.data.addNum2;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "addType1", {
        get: function () {
            if (FiasData.isGarHouse(this.data)) {
                return this.data.addType1;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "addType2", {
        get: function () {
            if (FiasData.isGarHouse(this.data)) {
                return this.data.addType2;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "flatNumber", {
        get: function () {
            if (FiasData.isRoom(this.data)) {
                return this.data.flatNumber;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "flatType", {
        get: function () {
            if (FiasData.isRoom(this.data)) {
                // verification expects flat type as string
                // https://git.skbkontur.ru/portal/portal/-/blob/4da72bd9ca/Portal.DataModel/Fias/Entities/VerifiableRoom.cs#L14
                return FiasFlatType[this.data.flatType];
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "flatFiasId", {
        get: function () {
            if (FiasData.isRoom(this.data)) {
                return this.data.flatFiasId;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "roomNumber", {
        get: function () {
            if (FiasData.isRoom(this.data) && this.flatFiasId) {
                return this.data.roomNumber;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasData.prototype, "roomType", {
        get: function () {
            if (FiasData.isRoom(this.data) && this.flatFiasId && this.data.roomType) {
                // verification expects room type as string
                // https://git.skbkontur.ru/portal/portal/-/blob/4da72bd9ca/Portal.DataModel/Fias/Entities/VerifiableRoom.cs#L23
                return FiasRoomType[this.data.roomType];
            }
        },
        enumerable: false,
        configurable: true
    });
    FiasData.isAddressObject = function (data) {
        return Boolean(data &&
            Object.prototype.hasOwnProperty.call(data, 'name') &&
            Object.prototype.hasOwnProperty.call(data, 'abbreviation'));
    };
    FiasData.isStead = function (data) {
        return Boolean(data &&
            Object.prototype.hasOwnProperty.call(data, 'number') &&
            Object.prototype.hasOwnProperty.call(data, 'liveStatus') &&
            !Object.prototype.hasOwnProperty.call(data, 'estateStatus'));
    };
    FiasData.isHouse = function (data) {
        return Boolean(data &&
            Object.prototype.hasOwnProperty.call(data, 'structureStatus') &&
            (Object.prototype.hasOwnProperty.call(data, 'number') ||
                Object.prototype.hasOwnProperty.call(data, 'structureNumber') ||
                Object.prototype.hasOwnProperty.call(data, 'buildingNumber')));
    };
    FiasData.isGarHouse = function (data) {
        return Boolean((data && Object.prototype.hasOwnProperty.call(data, 'houseNum')) ||
            Object.prototype.hasOwnProperty.call(data, 'houseType'));
    };
    FiasData.isRoom = function (data) {
        return Boolean(data &&
            Object.prototype.hasOwnProperty.call(data, 'flatType') &&
            Object.prototype.hasOwnProperty.call(data, 'flatNumber'));
    };
    FiasData.isRegion = function (data) {
        return Boolean(data && Object.prototype.hasOwnProperty.call(data, 'level') && data.level === 'Region');
    };
    return FiasData;
}());
export { FiasData };
